import React from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Fab,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ConfirmDialog from "../alertas/Confirm";
import { getPermissions, validatePermission } from "../../libs/permissions";
import api from "../../service/api";
import ActionFormDialog from "./DialogActionForm";
import DialogForm from "./DialogForm";
import Form from "./Forms";

class FormLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      forms: [],
      openDialogInsert: false,
      openForm: false,
      typeForm: props.options.type,
      titlePop: props.options.label,
      anchorEl: null,
      openMenu: false,
      form_atual: null,
      permissions: [],
      title: "",
      body: "",
      openDialogActions: false,
      openDialogConfirmDelete: false,
      loading: false,
      labelForm: "",
      form_id: null,
    };
  }

  componentDidMount() {
    validatePermission();
    this.getTypeForms();
    this.setPermission();
  }

  setPermission = () => {
    const permissionsRaw = getPermissions();
    const permissions = permissionsRaw ? JSON.parse(permissionsRaw) : null;
    this.setState({ permissions });
  };

  getTypeForms = () => {
    this.setState({ loading: true });
    const url = window.location.hostname;
    const urlSplit = url.split(".");
    api
      .get("/getType", {
        params: {
          type: this.state.typeForm,
          domain: urlSplit[0],
        },
      })
      .then((resp) => {
        this.setState({ forms: resp.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleClickOpen = () => {
    this.setState({ openDialogInsert: true, form_atual: null });
  };

  handleCloseDialog = () => {
    this.setState({ openDialogInsert: false, form_atual: null });
  };

  handleCloseDialogSave = () => {
    this.setState({ openDialogInsert: false, form_atual: null });
    this.getTypeForms();
  };

  handleClick = (event, form) => {
    this.setState({
      openMenu: true,
      anchorEl: event.currentTarget,
      form_atual: form,
    });
  };

  handleClose = () => {
    this.setState({
      openMenu: false,
      anchorEl: null,
      form_atual: null,
      openDialogConfirmDelete: false,
    });
  };

  handleCloseMenuOnly = () => {
    this.setState({
      openMenu: false,
      anchorEl: null,
    });
  };

  handleItem = (index) => {
    if (index === 1) {
      this.setState({ openDialogActions: true, openMenu: false, anchorEl: null });
      return;
    }
    this.setState({ openDialogInsert: true, openMenu: false, anchorEl: null });
  };

  deleteForm = () => {
    const form = this.state.form_atual;
    if (!form) {
      this.handleClose();
      return;
    }
    api.delete(`/forms/${form.id}`).then(() => {
      this.getTypeForms();
      this.handleClose();
    });
  };

  handleDelete = () => {
    this.setState({
      openDialogConfirmDelete: true,
      title: "Atencao",
      body: "Deseja deletar o formulario?",
      openMenu: false,
      anchorEl: null,
    });
  };

  handleOpenForm = (form) => {
    this.setState({
      openForm: true,
      labelForm: form.name,
      form_id: form.id,
    });
  };

  render() {
    const { classes } = this.props;

    if (this.state.openForm) {
      return (
        <Form
          labelForm={this.state.labelForm}
          form_id={this.state.form_id}
          close={() => this.setState({ openForm: false })}
        />
      );
    }

    return (
      <Paper className={classes.container}>
        <ActionFormDialog
          open={this.state.openDialogActions}
          onClose={() => this.setState({ openDialogActions: false, form_atual: null })}
          formId={this.state.form_atual}
        />
        {this.state.openDialogInsert && (
          <DialogForm
            form={this.state.form_atual}
            handleClose={this.handleCloseDialog}
            handleCloseSave={this.handleCloseDialogSave}
            type={this.state.typeForm}
          />
        )}
        {this.state.openDialogConfirmDelete && (
          <ConfirmDialog
            title={this.state.title}
            body={this.state.body}
            handleCloseConfirmT={this.deleteForm}
            handleCloseConfirmF={this.handleClose}
          />
        )}
        <div>
          <h1>{this.state.titlePop}</h1>
        </div>
        {this.state.permissions?.name === "SUPORTE" && (
          <div className={classes.action}>
            <Fab color="primary" aria-label="add" onClick={this.handleClickOpen}>
              <AddIcon />
            </Fab>
          </div>
        )}
        {this.state.loading && (
          <div className={classes.containerProgress}>
            <CircularProgress />
          </div>
        )}
        <div className={classes.cardContainer}>
          {this.state.forms.map((form) => (
            <Card className={classes.rootCard} key={form.id}>
              {this.state.permissions?.name === "SUPORTE" && (
                <CardHeader
                  action={
                    <IconButton aria-label="settings" onClick={(event) => this.handleClick(event, form)}>
                      <MoreVertIcon />
                    </IconButton>
                  }
                  classes={{ title: classes.contentHeader }}
                />
              )}
              <CardContent>
                <Typography variant="h5" component="h2">
                  {form.name}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={() => this.handleOpenForm(form)}>
                  Visualizar
                </Button>
              </CardActions>
            </Card>
          ))}
        </div>
        <Menu
          id="long-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.openMenu}
          onClose={this.handleCloseMenuOnly}
        >
          <MenuItem key={"Editar"} onClick={() => this.handleItem(0)}>
            {"Editar"}
          </MenuItem>
          <MenuItem key={"Botoes"} onClick={() => this.handleItem(1)}>
            {"Botoes de acao"}
          </MenuItem>
          <MenuItem key={"Excluir"} onClick={this.handleDelete}>
            {"Excluir"}
          </MenuItem>
        </Menu>
      </Paper>
    );
  }
}

const styles = () => ({
  container: {
    padding: 20,
  },
  cardContainer: {
    padding: 20,
    display: "flex",
    flexWrap: "wrap",
  },
  rootCard: {
    width: "275px",
    margin: "10px",
  },
  action: {
    padding: "5px",
    justifyContent: "end",
    display: "flex",
  },
  containerProgress: {
    textAlign: "center",
  },
  contentHeader: {
    fontSize: "16px",
    textAlign: "center",
  },
});

export default withStyles(styles)(FormLayout);
